module.exports = __webpack_public_path__ + "static/img/hiragana_small_tsu-compressor.b453338.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/hiragana_small_tsu-compressor.gif
// module id = 9Cjd
// module chunks = 0